/**
 * 客户端和服务端通用的语言文件映射逻辑
 *
 * 针对多区域站点，某些站点虽然使用 'en' 作为 locale，
 * 但应该加载对应的语言文件（如 uk.json、ca.json），
 * 而不是 en.json
 */

import { type Locale } from '@/i18n/config';

/**
 * 根据站点名称和 locale 获取正确的语言文件名
 *
 * @param locale 当前的 locale（如 'en', 'de', 'fr'）
 * @param siteName 站点名称（如 'uk', 'ca', 'us', 'de', 'fr'）
 * @returns 应该加载的语言文件名（如 'uk', 'ca', 'en'）
 */
export function getLocaleFileName(locale: Locale, siteName?: string): string {
  // 对于 UK 和 CA 站点，虽然 locale 是 'en'，但应该加载 'uk' 和 'ca' 文件
  if (['uk', 'ca'].includes(siteName || '')) {
    return siteName!;
  }

  // 其他情况直接使用 locale
  return locale;
}
